module.exports = __webpack_public_path__ + "media/site_templates/www.pianomovingservice.com.au/images/our_services_1-2499c6e974aa7a8b60db434640f5cab7.jpg";